import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Renderer2,
} from '@angular/core';

import * as deepEqual from 'fast-deep-equal';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import { LifeCycle } from '@recruitee/utils';

import {
  BaseTooltipComponent,
  ComponentPositionPair,
  ComponentTooltipPosition,
  ComponentTooltipService,
} from '../component-tooltip/component-tooltip.module';

export interface FeatureTooltipData {
  isNew: boolean;
  title: string;
  description: string;
  learnMore?: string;
  positions?: Partial<Record<ComponentTooltipPosition, ComponentPositionPair>>;
}

@Component({
  selector: 'rt-feature-tooltip',
  templateUrl: './feature-tooltip.component.html',
  styleUrls: ['./feature-tooltip.component.less'],
})
export class FeatureTooltipComponent extends BaseTooltipComponent implements OnInit {
  public data: FeatureTooltipData;

  public close$ = new EventEmitter<void>();
  public learnMoreClick$ = new EventEmitter<void>();

  @LifeCycle('onDestroy')
  public ngOnDestroy$: Subject<void>;

  constructor(
    private cdRef: ChangeDetectorRef,
    private componentTooltipService: ComponentTooltipService<
      typeof FeatureTooltipComponent,
      FeatureTooltipData
    >,
    elementRef: ElementRef,
    renderer2: Renderer2,
  ) {
    super(elementRef, renderer2);
  }

  public ngOnInit(): void {
    this.componentTooltipService.data$
      .pipe(
        distinctUntilChanged((a, b) => deepEqual(a, b)),
        filterBoolean,
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe(data => {
        this.data = data;
        this.cdRef.detectChanges();
      });
  }
}
